<template>
  <div id="myModal" class="modal-background">
    <div class="modal modal--subscription">
      <div class="modal-header">
        <span class="close" @click="onClose()"
          ><img
            class="selected-filter__remove-icon"
            src="/Themes/Striep2/Content/svg/x.svg"
            style="width: 28px"
        /></span>
        <h2>Waarschuw mij wanneer beschikbaar</h2>
      </div>
      <div class="modal-body" v-html="html">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subscribe-back-instock-dialog",
  props: ["html"],
  mounted: function () {
    document
      .querySelector("#back-in-stock-notify-me")
      .addEventListener("click", () => {
        let url = document
          .querySelector("#backinstock-url")
          .getAttribute("data-value");
        let productId = document
          .querySelector("#backinstock-productid")
          .getAttribute("data-value");
        fetch(url, {
          method: "post",
          body: `productId: ${productId}`,
        })
          .then(() => {
            this.onClose();
          })
          .catch(() => {
            alert('Er ging iets mis, probeer het later opnieuw');
          });
      });
  },
  methods: {
    onClose: function () {
        this.$emit("closedialog", this.searchfacet);
        document.querySelector('.master-wrapper-content').style.zIndex = "0"
    },
  }
};
</script>

<style>
</style>